// material-ui
import { Typography } from '@mui/material'

// project imports
import { useHasPermission } from '../../../../../app/hooks'
import { MenuItem } from '../../../../../types'
import menuItems from '../../../../menu-items'
import NavGroup from './NavGroup'

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const navItems = menuItems().map((item: MenuItem) => {
    const check = useHasPermission(item?.premissions || [])
    if (check) {
      switch (item?.type) {
        case 'group':
          return <NavGroup key={item?.id} item={item} />
        default:
          return (
            <Typography key={item?.id} variant='h6' color='error' align='center'>
              Menu Items Error
            </Typography>
          )
      }
    }
    return ''
  })

  return <>{navItems}</>
}

export default MenuList
